import Navbar from './components/Navbar';
import Calculate from './components/Calculate';

function App() {
  return (
       <>
       <Navbar />
        <Calculate />
       </>
  );
}

export default App;
